/** @jsxImportSource theme-ui */

import React from 'react';
import icons from './Icons';
import { sizing } from '../../tokens';
import { ResponsiveStyleValue, IconButton as ThemeUiIconButton } from 'theme-ui';
import { getVariant } from '../utils';
import { AllCaroteneColors, IconSizing, StyleOverrideProps } from '../utils/types';

type IconName = keyof typeof icons;
type IconColor = ResponsiveStyleValue<AllCaroteneColors>;
type IconSize = ResponsiveStyleValue<IconSizing>;
export interface IconProps extends StyleOverrideProps {
    name: IconName;
    color?: IconColor;
    size?: IconSize;
    title?: string;
}

function Icon({ name, size, color, title, sx, ...otherProps }: IconProps): JSX.Element {
    const iconDetails = icons[name];
    const calculatedSize = size || iconDetails.defaultSize;
    return (
        <svg
            sx={{
                color,
                height: '100%',
                width: sizing.icons[calculatedSize as keyof typeof sizing.icons] || calculatedSize,
                fill: 'currentColor',
                ...sx,
            }}
            {...otherProps}
            viewBox={`0 0 ${iconDetails.dimensions.width} ${iconDetails.dimensions.height}`}
        >
            {title ? <title>{title}</title> : null}
            <path d={iconDetails.path} fillRule={iconDetails.fillRule} />
        </svg>
    );
}

type IconButtonProps = {
    icon: React.ReactNode;
    'aria-label': string;
    disabled?: boolean;
};
function IconButton({ icon, ...otherProps }: IconButtonProps): JSX.Element {
    return (
        <ThemeUiIconButton sx={{ variant: getVariant({ stylePath: 'buttons.icon' }) }} {...otherProps}>
            {icon}
        </ThemeUiIconButton>
    );
}

IconButton.defaultProps = {
    disabled: false,
};

export { Icon, IconName, IconButton, IconButtonProps, icons };
